import { Injectable } from "@angular/core";
var url = "";
const host = window.location.hostname;
if (host.includes("localhost")) {
	url = "http://localhost:18151/api/";
}
else if (host.includes("wonderful-forest-092dc1d0f")) {
	url = "https://forms-service-hjescebwchcwd2g6.eastus2-01.azurewebsites.net/api/";
}
else if (host.includes("forms-dev.snapone.com")) {
	url = "https://forms-dev.snapone.com:8443/api/";
}
else if (host.includes("forms.control4.com")) {
	url = "https://forms.control4.com:8443/api/";
}
else if (host.includes("forms.snapone.com")) {
	url = "https://forms.snapone.com:8443/api/";
}
else if (host.includes("globalformsadi.com") || host.includes("adidirectpurchasing.com")) {
	url = "https://forms-serivce-prod-afchhagrguhza9bj.eastus2-01.azurewebsites.net/api/";
}
@Injectable()
export class Constants {
	user: IAuthenticationModel;

	static restUrl = url;
	static attachtmentsUrl = url;
	static helpGuideDocumentUrl = "https://wirepath.sharepoint.com/sites/GlobalPurchasingTeam/_layouts/15/guestaccess.aspx?share=EfkWoRpvRG9HsM5bEeed98ABe5pwK_qtnVp2992oJKC9iA&e=hM9E7T";
	constructor() {
		if (localStorage.getItem("user"))
			this.user = JSON.parse(atob(localStorage.getItem("user")));
	}
}